<template>
	<div class="bodily">
		<!-- <h3 class="qjc-fts-16 qjc-c-dark qjc-ftw-500">新生兒信息</h3> -->
		<div class="insert-title">寶寶信息</div>
		
		<el-form
			:model="formData"
			:rules="rules"
			inline
			:hide-required-asterisk="true"
			ref="newbornForm"
		>
			<el-form-item
				label="媽媽的生育年齡："
				label-width="130px"
				class="item-100"
				prop="mage"
			>
				<el-input
					v-model="formData.mage"
					placeholder="請輸入"
				></el-input>
				歲
			</el-form-item>
			
			<el-form-item
				label="寶寶的出生孕周："
				label-width="130px"
				prop="week"
			>
				<el-input
					v-model="formData.week"
					placeholder="請輸入"
				></el-input>
				周
			</el-form-item>
			
			<el-form-item
				label="寶寶的出生體重："
				label-width="130px"
				prop="bweight"
			>
				<el-input
					v-model="formData.bweight"
					placeholder="請輸入"
				></el-input>
				g
			</el-form-item>
			
			<el-form-item
				label="寶寶的性別："
				label-width="130px"
				prop="bsex"
			>
				<el-select
					v-model="formData.bsex"
				>
					<el-option
						label="男"
						:value="1"
					></el-option>
					<el-option
						label="女"
						:value="2"
					></el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item
				label="APGAR分數："
				label-width="130px"
				prop="aps1"
				class="apgar"
			>
				<el-input
					v-model="formData.aps1"
					placeholder="請輸入"
				></el-input>
				分
			</el-form-item>
			
		</el-form>
		<div class="footer-btn">
			<el-button @click="handlePrev" class="prev qjc-fts-16 qjc-block">上一步</el-button>
			<el-button @click="next" class="next qjc-fts-16 qjc-block">下一步</el-button>
		</div>
		<!-- <el-button @click="next" class="next qjc-fts-16 qjc-ftw-500">下一步</el-button> -->
		
	</div>
</template>

<script>
	let numberInput = function (value) {
		var price = '' + value;
		price = price
		    .replace(/[^\d.]/g, '') // 清除“數字”和“.”以外的字符
		    .replace(/\.{2,}/g, '.') // 只保留第一個. 清除多餘的
		    .replace('.', '$#$')
		    .replace(/\./g, '')
		    .replace('$#$', '.')
		    .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); // 只能輸入兩個小數
		if (price.indexOf('.') < 0 && price != '') {
		    // 以上已經過濾，此處控制的是如果沒有小數點，首位不能為類似於 01、02的金額
		    price = parseFloat(price);
		}
		return price
	}
	export default{
		name: 'newbornComplex',
		data() {
			var apgarVerify = (rule, value, callback) => {
				if(numberInput(value)) {
					if(numberInput(value) < 0 || numberInput(value) > 10){
						callback(new Error('APGAR分數——即新生兒評分(第一分鐘)為0~10'));
					}else{
						callback();
					}
				} else {
					callback(new Error('APGAR分數——即新生兒評分(第一分鐘)為0~10'));
				}
			}
			var weekVerify = (rule, value, callback) => {
				if(numberInput(value)) {
					callback();
				} else {
					callback(new Error('請輸入寶寶正確的的出生孕周'));
				}
			}
			var mageVerify = (rule, value, callback) => {
				if(numberInput(value)) {
					callback();
				} else {
					callback(new Error('請輸入媽媽正確的生育年齡'));
				}
			}
			var bweightVerify = (rule, value, callback) => {
				if(numberInput(value)) {
					callback();
				} else {
					callback(new Error('請輸入寶寶正確的出生體重'));
				}
			}
			
			return {
				rules: {
					bsex: [
						{ required: true, message: '請選擇入寶寶性別', trigger: 'change' }
					],
					mage: [
						{ required: true, message: '請輸入媽媽的生育年齡', trigger: 'blur' },
						{ validator: mageVerify, trigger: 'blur' }
					],
					week: [
						{ required: true, message: '請輸入寶寶的出生孕周：', trigger: 'blur' },
						{ validator: weekVerify, trigger: 'blur' }
					],
					bweight: [
						{ required: true, message: '請輸入寶寶的出生體重：', trigger: 'blur' },
						{ validator: bweightVerify, trigger: 'blur' }
					],
					aps1: [
						{ required: true, message: '請輸入APGAR分數——即新生兒評分(第一分鐘)', trigger: 'blur' },
						{ validator: apgarVerify, trigger: 'blur' }
					],
				}
			}
		},
		props: ['formData'],
		methods: {
			next() {
				this.$refs.newbornForm.validate((isSuc) => {
					if(isSuc){
						this.$emit('checkTab', 'Biochemical');
					}
				});
			},
			handlePrev() {
				this.$emit('checkTab', 'Puerpera');
			},
		}
	}
</script>

<style scoped>
	.el-form >>> .el-form-item__content,
	.el-form >>> .el-form-item__label{
		font-size: 14px;
	}
	.e/* l-form .el-input >>> input, */
	.el-select >>> .el-input__inner{
		width: 200px;
		height: 32px;
		font-size: 14px;
		line-height: 14px;
		padding: 9px 16px;
	}
	.el-form >>> .el-form-item__content,
	.el-form >>> .el-form-item__label{
		vertical-align: middle;
	}
	.el-form >>> .el-form-item__label{
		min-width: 114px;
		line-height: 32px;
		text-align: left;
		padding-right: 0;
	}
	.bodily >>> .el-form-item__label{
		font-size: 14px;
		color: #777F8F;
		padding-right: 10px;
		text-align: right;
	}
	.bodily >>> .el-input{
		width: 400px;
		height: 34px;
		line-height: 34px;
	}
	.bodily >>> .el-input input{
		width: 400px;
		height: 34px;
		font-size: 14px;
		line-height: 14px;
		padding: 9px 12px;
	}
	.bodily >>> .el-select .el-input .el-select__caret {
		line-height: 24px;
	}
</style>
<style lang="scss" scoped>
	.bodily{
		padding-top: 32px;
		
		.insert-title {
			position: relative;
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #293033;
			line-height: 16px;
			padding-bottom: 15px;
			border-bottom: 1px solid #E5E8F5;
			margin-bottom: 32px;
			
			&::before{
				position: absolute;
				left: -24px;
				top: 0;
				content: '';
				width: 4px;
				height: 20px;
				background-color: #6883FB;
			}
		}
		
		.el-form-item{
			// margin: 24px 80px 0 0;
			// min-width: 500px;
			width: 48%;
			
			
		}
		.next-form-item {
			margin-right: 0 !important;
		}
		.footer-btn {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 40px;
		}
				
		.next{
			width: 96px;
			height: 34px;
			border-radius: 17px;
			border: none;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #fff;
		}
		.prev {
			width: 96px;
			height: 34px;
			border-radius: 17px;
			border: 1px solid #6883FB;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #6883FB;
			background-color: #fff;
			margin-right: 24px;
		}
		
		.el-form{
			margin-top: 14px;
			
			.el-form-item{
				// margin-right: 0.72px;
				margin-bottom: 20px;
				
				&.apgar{
					// margin-left: 0.2px;
				}
				
				&:nth-child(3n){
					margin-right: 0;
				}
				
				.el-input{
					width: auto;
				}
			}
		}
		
		.item-100 {
			width: 100%;
		}
		
		// .next{
		// 	display: block;
		// 	width: 2px;
		// 	height: 0.48px;
		// 	line-height: 0.48px;
		// 	margin: 0.6rem auto 0;
		// }
	}
</style>
